import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate } from '@angular/router';
import { AuthService } from '../auth.service';

// Auth Services


@Injectable({ providedIn: 'root' })
export class OnlyHomePageGuard implements CanActivate {
  constructor(private router: Router, private authService: AuthService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    // Get current user from auth service or local storage fallback
    const currentUser = this.authService.currentUserValue;
    const storedUser =
      currentUser ||
      (localStorage.getItem('currentUser') &&
        JSON.parse(localStorage.getItem('currentUser')!));

    // If the user is a Student, block access to the home page
    if (storedUser && storedUser.role === 'Student') {
      this.router.navigate(['/my-learning'], { queryParams: { returnUrl: state.url } });
      return false;
    }

    // Otherwise (Teacher, Admin, Guest, etc.) allow access
    return true;
  }
}
